import {useCollapsibleSidebarContext} from '@github-ui/layout-primitives/CollapsibleSidebar'
import {Sidebar} from '@github-ui/layout-primitives/Sidebar'
import {WorkflowSidebarManagement, type WorkflowSidebarManagementProps} from './WorkflowSidebarManagement'

export function WorkflowSidebarFooter(props: WorkflowSidebarManagementProps) {
  const {isInDialog} = useCollapsibleSidebarContext()

  return (
    <Sidebar.Footer>
      <WorkflowSidebarManagement {...props} />
      {!isInDialog && (
        <Sidebar.Section divider>
          <Sidebar.CollapseButton />
        </Sidebar.Section>
      )}
    </Sidebar.Footer>
  )
}
